import React from "react"
import { useTranslation } from "react-i18next"
import GetEnvironment from "../../environments"
import { AccountAdmin, PolicyType, ProjectCreatedWithStatus } from "../../types"
import { ConfigStatus } from "./ConfigMain"
import { ProgressBanner } from "./ProgressBanner"
import Modal from "../Modal"

// Contains the button and the progress banner
const QuadriHeader = (props: {
  configStatus: ConfigStatus
  isEnableButtonHidden?: boolean
  isEnableButtonDisabled?: boolean
  statusMessage?: string
  updateErrorMessage?: string
  createProjectResponse: any
  submitQuadriProject: (e: any) => void
  createdAt?: string
  updatedAt?: string
  permissionsUpdatedAt?: string
  projectCreatedWithStatus?: ProjectCreatedWithStatus
  showMessage: {
    show: boolean
    for: string
    accountName: string | undefined
  }
  closeMessageModal: () => void
  allowedRegions: string
  accountAdmins: AccountAdmin[]
  openPanel?: () => void
  closePanel?: () => void
  showPermissionsPanel: boolean
  onDisable?: () => void
}) => {
  const {
    configStatus,
    isEnableButtonHidden,
    isEnableButtonDisabled,
    createdAt,
    updatedAt,
    permissionsUpdatedAt,
    openPanel,
    closePanel,
    showPermissionsPanel
  } = props
  const { statusMessage, createProjectResponse, submitQuadriProject } = props
  const { updateErrorMessage, projectCreatedWithStatus } = props
  const [showAllAdmins, setShowAllAdmins] = React.useState(false)
  const displayedAdmins = showAllAdmins ? props.accountAdmins : props.accountAdmins.slice(0, 10)
  const { t } = useTranslation("config")

  return (
    <div className="row">
      <div className="col-12 head-container mt-1">
        <div className="page-heading mt-0">
          <h1>{t("quadriHeader.title")}</h1>
          {props.showMessage.show && props.showMessage.for === PolicyType.extensionActivationAndRemovalPolicy && (
            <Modal heading={t("extensionPolicy.heading")} closeModal={props.closeMessageModal} large={true}>
              <div>{t("extensionPolicy.enable") + props.showMessage.accountName + t("extensionPolicy.commonText")}</div>
              <br />
              <ul>
                {displayedAdmins.map((admin: AccountAdmin, index: number) => (
                  <li key={index}>
                    <strong>{admin.fullName}</strong> ({admin.email})
                  </li>
                ))}
              </ul>
              {/* Show "Show More" or "Show Less" link based on admin count */}
              {props.accountAdmins.length > 10 && !showAllAdmins && (
                <button
                  className="m-0 p-0"
                  onClick={() => setShowAllAdmins(true)}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#005F9E" }}
                >
                  {t("extensionPolicy.showMore")}
                </button>
              )}
              {showAllAdmins && (
                <button
                  onClick={() => setShowAllAdmins(false)}
                  className="m-0 p-0"
                  style={{ background: "none", border: "none", cursor: "pointer", color: "#005F9E" }}
                >
                  {t("extensionPolicy.showLess")}
                </button>
              )}
            </Modal>
          )}
          {props.showMessage.show && props.showMessage.for === PolicyType.regionPolicy && (
            <Modal heading={t("regionPolicy.heading")} closeModal={props.closeMessageModal} large={true}>
              <div>{t("regionPolicy.enable") + " " + props.allowedRegions}</div>
            </Modal>
          )}
        </div>
      </div>

      {(configStatus === "Creating" || configStatus === "Active" || configStatus === "Failed") && (
        <ProgressBanner
          retryProcess={submitQuadriProject}
          configStatus={configStatus}
          errorMessage={statusMessage || createProjectResponse.error?.message}
          updateErrorMessage={updateErrorMessage}
          disableRetry={isEnableButtonHidden}
          createdAt={createdAt}
          updatedAt={updatedAt}
          permissionsUpdatedAt={permissionsUpdatedAt}
          projectCreatedWithStatus={projectCreatedWithStatus}
          openPanel={openPanel}
          closePanel={closePanel}
          showPermissionsPanel={showPermissionsPanel}
          onDisable={props.onDisable}
        />
      )}
    </div>
  )
}

export default QuadriHeader
